import { render, staticRenderFns } from "./contact-info-edit.vue?vue&type=template&id=20cea051&scoped=true"
import script from "./contact-info-edit.vue?vue&type=script&lang=js"
export * from "./contact-info-edit.vue?vue&type=script&lang=js"
import style0 from "./contact-info-edit.vue?vue&type=style&index=0&id=20cea051&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cea051",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cea051')) {
      api.createRecord('20cea051', component.options)
    } else {
      api.reload('20cea051', component.options)
    }
    module.hot.accept("./contact-info-edit.vue?vue&type=template&id=20cea051&scoped=true", function () {
      api.rerender('20cea051', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/contact-info-edit.vue"
export default component.exports